import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import UploadIcon from '@interxfi/design-system/icons/react/icon-upload';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { FincenFilesTable } from '../../../../../../../../../../features/watchlist/fincen/file/fincen-files-table';
import { UploadFincenFileModal } from '../../../../../../../../../../features/watchlist/fincen/file/upload-fincen-file-modal';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/file/_file/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingComplianceFincen,
      label: 'Files',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingComplianceFincen>,
  head: () => getPageHead('FinCEN Files'),
  component: FincenFileList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <UploadFincenFileModal trigger={<Button affixIcon={<UploadIcon aria-hidden />} aria-label="Upload FinCEN File" size="small" />} />
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingComplianceFincen}
    />
  );
}

function FincenFileList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <FincenFilesTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
